const ssn = {
    ssn : {
        value: "",
        dbqName: "F[0].Page-1[0].SSN[0]"
     },
     examDate: {
        value: "",
        dbqName: "F[0].Page-1[0].DateOfExam[0]"
    },
     docName: {
         value: "",
         dbqName: "F[0].NEWPAGE[0].ProstateCA[0].SectionXVI-ExaminersCertSign[0].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "F[0].NEWPAGE[0].ProstateCA[0].SectionXVI-ExaminersCertSign[0].TextField8[6]"
    },
     docDate: {
        value : "",
        dbqName: "F[0].NEWPAGE[0].ProstateCA[0].SectionXVI-ExaminersCertSign[0].TextField8[7]"
    },
     docNpi: {
         value : "",
         dbqName: "F[0].NEWPAGE[0].ProstateCA[0].SectionXVI-ExaminersCertSign[0].TextField8[3]"
     },
     docPhone: {
        value : "",
        dbqName: "F[0].NEWPAGE[0].ProstateCA[0].SectionXVI-ExaminersCertSign[0].TextField8[2]"
    },
    docLicenseNo: {
        value : "",
        dbqName: "F[0].NEWPAGE[0].ProstateCA[0].SectionXVI-ExaminersCertSign[0].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "F[0].NEWPAGE[0].ProstateCA[0].SectionXVI-ExaminersCertSign[0].TextField8[5]"
    },
    diagnosisDate : [
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].CheckBox4[5]",
            dateDbqName: "F[0].Page_2[0].DateofDiagnosis[11]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].CheckBox4[4]",
            dateDbqName: "F[0].Page_2[0].DateofDiagnosis[10]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].CheckBox4[3]",
            dateDbqName: "F[0].Page_2[0].DateofDiagnosis[9]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].CheckBox4[2]",
            dateDbqName: "F[0].Page_2[0].DateofDiagnosis[8]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].CheckBox4[0]",
            dateDbqName: "F[0].Page_2[0].DateofDiagnosis[3]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].CheckBox24[1]",
            dateDbqName: "F[0].Page_2[0].DateofDiagnosis[5]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].CheckBox5[0]",
            dateDbqName: "F[0].Page_2[0].DateofDiagnosis[7]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].CheckBox4[1]",
            dateDbqName: "F[0].Page_2[0].DateofDiagnosis[6]",
        },
        {
            type: "checkbox",
            dbqName: "F[0].Page_2[0].CheckBox1[0]",
            dateDbqName: "F[0].Page_2[0].DateofDiagnosis[4]",
        },
        {
            type: "text",
            dbqName: "F[0].Page_2[0].Otherdiagnosis1[0]",
            dateDbqName: "F[0].Page_2[0].DateofDiagnosis[0]",
        },
        {
            type: "text",
            dbqName: "F[0].Page_2[0].Otherdiagnosis2[0]",
            dateDbqName: "F[0].Page_2[0].DateofDiagnosis[1]",
        },        
    ]

}

export default ssn ;